// Style d'anneau (dégradé conique aux couleurs du pays) autour d'une photo ronde.
// Renvoie null s'il n'y a pas de couleurs -> on garde le liseré doré par défaut.
export const ringStyle = (colors) => {
  if (!colors || !colors.length) return null;
  const stops = colors.length === 1 ? [colors[0], colors[0]] : [...colors, colors[0]];
  return { background: `conic-gradient(from 0deg, ${stops.join(", ")})` };
};
